<template>
  <section id="tableofcontent">
    <div class="demo">
        <nav role="navigation" aria-label="Table of content" class="toc">
            <h5 aria-hidden="true">Content</h5>
            <ol>
                <li class="active"><a href="#section1" aria-selected="true">Section heading 1</a>
                </li>
                <li><a href="#" aria-selected="false">Section heading 2</a></li>
                <li><a href="#" aria-selected="false">Section heading 3</a></li>
                <li><a href="#" aria-selected="false">Section heading 4</a></li>
                <li><a href="#" aria-selected="false">Section heading 5</a></li>
                <li><a href="#" aria-selected="false">Section heading 6</a></li>
            </ol>
        </nav>
    </div>
    <section class="md" v-html="mdfile"></section>
  </section>
</template>

<script>
import mdfile from "@/docs/components/toc.md";
export default {
  name: "tableofcontent",
  beforeCreate: function() {
    this.$emit("update-title", this.$root.yamlData.components.tableofcontent.name);
    this.$emit(
      "update-tagline",
      this.$root.yamlData.components.tableofcontent.description
    );
  },
  data() {
    return {
      mdfile
    };
  }
};
</script>
